import { styled, css } from 'next-yak'

import * as colors from '../constants/colors'
import * as effects from '../constants/effects'
import { Icon } from '../icons/glyphs'

export const DropdownStyle = css`
  background-color: ${colors.PRIMARY_GREY_000};
  box-shadow: ${effects.SHADOW_1};
`

export const Dropdown = styled.div`
  ${DropdownStyle}
`

export const MenuDropdownTitle = styled.div<{ $isOpen: boolean }>`
  ${Icon} {
    margin-right: 7px;
  }

  a {
    ${({ $isOpen }) => {
      if ($isOpen) {
        return css`
          color: ${colors.TEXT_LINK};
        `
      }
    }};
  }
`
